import { OnlyViewHoc } from 'hocs'
import React from 'react'

import { useLogisticCartFilters } from 'hooks/useLogisticCartFilters'
import { logisticCartApi } from 'redux/services/logistic-cart'
import { LogisticCartReportType } from 'redux/services/logistic-cart/types'

import { AppButton } from 'components/AppButton'
import AppDatePicker from 'components/AppDatePicker/AppDatePicker'
import { AppFiltersLayout } from 'components/AppFiltersLayout'
import { AppSelect } from 'components/AppSelect'
import { TextField } from 'components/TextField'

import { LOGISTIC_CART_STATUS_TEXT } from 'constants/logistic-cart'

interface Props {
  onSubmit?: () => void
  reset?: () => void
}

const defaultListValue = {
  title: 'Все',
  value: '',
}

export const Filters: React.FC<Props> = ({ onSubmit, reset }) => {
  const { params, setParam } = useLogisticCartFilters()
  const [downloadExcel, downloadExcelState] =
    logisticCartApi.useDownloadLogisticCartExcelMutation()

  const statusList = Object.entries(LOGISTIC_CART_STATUS_TEXT).map(
    ([value, title]) => ({
      title,
      value,
    }),
  )

  return (
    <AppFiltersLayout
      controls={
        <>
          <AppButton size="small" onClick={onSubmit}>
            Применить
          </AppButton>
          <AppButton size="small" variant="red" onClick={reset}>
            Сбросить
          </AppButton>
          <OnlyViewHoc>
            <AppButton
              onClick={() => downloadExcel({ params })}
              disabled={downloadExcelState.isLoading}
              variant="siren_dashed_border"
              size="small"
            >
              Скачать отчет
            </AppButton>
            <AppButton
              onClick={() =>
                downloadExcel({ params, type: LogisticCartReportType.BY_USERS })
              }
              disabled={downloadExcelState.isLoading}
              variant="siren_dashed_border"
              size="small"
            >
              Отчет по заявкам
            </AppButton>
          </OnlyViewHoc>
        </>
      }
    >
      <TextField
        inputSize="small"
        onChange={e => setParam('search', e.currentTarget.value)}
        value={params.search}
        name="search"
        label="Название"
        placeholder="Введите название"
      />

      <TextField
        inputSize="small"
        onChange={e => setParam('pan', e.currentTarget.value)}
        value={params.pan}
        name="pan"
        label="ПАН"
        placeholder="Введите ПАН"
      />

      <AppSelect
        size="extra_small"
        text={statusList.find(item => item.value === params.status)?.title}
        onChangeValues={value => setParam('status', value?.[0] || '')}
        list={[defaultListValue, ...statusList]}
        placeholder="Все"
        label="Статус"
      />

      <AppDatePicker
        label="Начало"
        inputSize="small"
        value={params.start_date || ''}
        onchange={date => {
          setParam('start_date', date)
        }}
      />

      <AppDatePicker
        label="Конец"
        inputSize="small"
        value={params.end_date || ''}
        onchange={date => {
          setParam('end_date', date)
        }}
      />
    </AppFiltersLayout>
  )
}
